<template>
    <modal name="DocumentListBarang" :draggable="false" :scrollable="true" :height="'auto'">
      <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
        <div class="modal-dialog  modal-xl">
          <div class="modal-content">
  
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel"> List Barang </h5>
              <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
  
            <div class="modal-body">
              <vue-good-table title="list-dokumen-fasilitas" :rows="rowsDokumenFasilitas" :columns="columnFasilitas" :line-numbers="true" 
                >
                <div slot="emptystate">
                  Empty Row
                </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'vds'">
                    {{sumVd(props.row.vd) }}
                  </span>
                  <!-- <span v-else-if="props.column.field == 'fasilitas'">
                    {{ props.row.kodeFasilitas + " - " + props.row.namaFasilitas }}
                  </span>
                  <span v-else-if="props.column.field == 'izin'">
                    <input type="text" class="form-control" v-model="props.row[props.column.field]"
                      @change="changeCell(props.row[props.column.field], props.column.field, props.row.originalIndex)">
                  </span>
                   -->
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
            </div>
  
          </div>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    name: "DocumentListFasilitas",
    props: {
      propsData: { type: [Object, Array] }
    },
    data() {
      return {
        rowsDokumenFasilitas: [],
        columnFasilitas: [
          {
            label: "Hs",
            field: 'hsCode',
            type: 'text',
            thClass: 'text-center',
            tdClass:'text-center',
          },
          {
            label: "CIF",
            field: 'cif',
            type: 'text',
            thClass: 'text-center',
            tdClass:'text-center',
          },
          {
            label: "VD",
            field: 'vds',
            type: 'text',
            thClass: 'text-center',
            tdClass:'text-center',
          },
          {
            label: "FOB",
            field: 'fob',
            type: 'text',
            thClass: 'text-center',
            tdClass:'text-center',
          },
          {
            label: "BTP",
            field: 'btp',
            type: 'text',
            width: "200px",
            thClass: 'text-center',
            tdClass:'text-center',
          },
        ],
        selectedRow: [],
        forms:null,
      }
    },
    methods: {
      sumVd(vd){
        var a = 0;
        if(vd && vd.length > 0){
          vd.forEach(el=>{
            a += parseFloat(el.nilaiBarangVd);
          });
        }

        return a;
      },
      removeModals() {
        this.$modal.hide('DocumentListBarang');
      },
      changeCell(changedData, column, row) {
        this.rowsDokumenFasilitas[row][column] = changedData
      },
      selectionChanged(ev) {
        this.selectedRow = [];
        this.selectedRow = ev.selectedRows;
      },
      submitData(){
        this.$emit("closeModal",this.selectedRow);
        this.removeModals();
      },
      reAssignValue(){
        this.rowsDokumenFasilitas = this.forms;
      },
    },
    created() { },
    watch: {
      propsData: function (newVal) {
        this.forms = newVal;
        this.reAssignValue();
        // this.rowsDokumenFasilitas = newVal;
        // this.reAssignValue();
  
      },
    }
  }
  </script>
  
  <style></style>